export default function ImageService(Upload, $http) {
  return {
    uploadFile: uploadFile,
    uploadDataUrl: uploadDataUrl
  };

  function uploadFile(endpoint, file) {
    return Upload.upload({
      url: endpoint,
      method: 'POST',
      file: file
    });
  }

  function uploadDataUrl(endpoint, url) {
    return $http.post(endpoint, {
      image: url
    });
  }
}

ImageService.$inject = ['Upload', '$http'];
